import { ClientAttachmentId, ClientItemId } from 'owa-client-ids';
import { ComposeViewState } from 'owa-mail-compose-store';
import createAttachments from 'owa-mail-compose-actions/lib/utils/createAttachments';
import { createLocalComputerFiles } from 'owa-attachment-file-types';
import { ApiErrorCode } from 'owa-addins-core';
import { AttachmentBlob } from 'owa-mail-compose-actions/lib/utils/attachmentBlob';
import { isImageFile } from 'owa-file';
import { onAttachmentCreated } from 'owa-attachment-well-data';
import AttachmentType from 'owa-service/lib/contract/AttachmentType';

export default function createAttachmentFromBase64String(
    viewState: ComposeViewState,
    base64String: string,
    attachmentName: string,
    isInline: boolean
): Promise<string> {
    return new Promise<string>((resolve, reject) => {
        let hasProcessed = false;

        const attachmentErrorHandler = () => {
            if (!hasProcessed) {
                hasProcessed = true;
                reject({ errorType: 'UploadError' });
            }
        };

        const onAttachmentCreatedCallback = (
            parentItemId: ClientItemId,
            attachmentId: ClientAttachmentId,
            attachment: AttachmentType
        ) => {
            onAttachmentCreated(parentItemId, attachmentId, attachment);
            resolve(attachmentId.Id);
        };

        const onFinish = (attachmentId: ClientAttachmentId) => {
            if (!hasProcessed) {
                hasProcessed = true;
                resolve(attachmentId.Id);
            }
        };

        try {
            const attachmentContent = atob(base64String);
            const attachmentContentLength = attachmentContent.length;
            const byteArray = new Uint8Array(new ArrayBuffer(attachmentContentLength));

            for (let i = 0; i < attachmentContentLength; i++) {
                byteArray[i] = attachmentContent.charCodeAt(i);
            }

            var blob = null;
            if (isImageFile(attachmentName)) {
                blob = new Blob([byteArray], { type: 'image/png' });
            } else {
                blob = new Blob([byteArray]);
            }

            var attachmentBlob: AttachmentBlob = blob;
            attachmentBlob.name = attachmentName;

            const localComputerFileList = createLocalComputerFiles([<File>attachmentBlob]);

            createAttachments(
                localComputerFileList,
                viewState,
                {
                    isInline,
                    isHiddenInline: true,
                    shouldShare: false,
                },
                onFinish,
                onAttachmentCreatedCallback,
                attachmentErrorHandler
            );
        } catch (err) {
            reject({ errorType: ApiErrorCode.AttachmentUploadGeneralFailure });
        }
    });
}
